import HBSwiper from "@/components/HBSwiper";
import Card from "./card";
import styles from "./index.module.less";
export default function Schedule(props) {
  const { calendarsList, festival, clickCard, autoScroll } = props;

  return (
    <div className={styles.swiperContent}>
      <HBSwiper className={styles.swiper} iconClassName={styles.icon}>
        <div className={styles.list}>
          {calendarsList.map((item) => {
            return (
              <Card
                festivalInfo={item}
                key={item.code}
                festival={festival}
                clickCard={clickCard}
                autoScroll={autoScroll}
              ></Card>
            );
          })}
        </div>
      </HBSwiper>
    </div>
  );
}
